module.exports = __webpack_public_path__ + "static/media/VisaImage.3aaad187.svg";